import { render, staticRenderFns } from "./external-income-table.component.html?vue&type=template&id=07495c2a&scoped=true&"
import script from "./external-income-table.component.ts?vue&type=script&lang=ts&"
export * from "./external-income-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./external-income-table.component.scss?vue&type=style&index=0&id=07495c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07495c2a",
  null
  
)

export default component.exports